module.exports = __webpack_public_path__ + "static/img/11.b51437c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/cards/zombs/11.png
// module id = RY/V
// module chunks = 35